import { Box, Grid, GridItem } from '@sequencehq/core-components'
import { ReactNode } from 'react'

/**
 * Handles large screens whilst retaining a consistent layout - keeps
 * the fixed width form centered within the container.
 *
 * However, don't feel the need to over-extend this layout for different
 * task designs! If it's not convenient, don't use it, and create a new layout
 * that suits the design.
 * @param param0
 * @returns
 */
export const StepLayout = ({
  title,
  children,
  footer,
  'data-testid': testId
}: {
  title: ReactNode
  children: ReactNode
  footer?: ReactNode
  'data-testid'?: string
}) => {
  return (
    <Grid
      data-testid={testId}
      justifyContent="center"
      flexDirection="column"
      width="fit-content"
      height="100%"
      gridTemplateRows="1fr auto"
      gridTemplateAreas={`
        "content content content"
        "footer footer footer"
      `}
      position="relative"
    >
      <Box padding="24px" gridArea="content" overflowY="auto">
        {title}
        <Box>{children}</Box>
      </Box>
      <GridItem gridArea="footer" width="100%">
        {footer}
      </GridItem>
    </Grid>
  )
}
